<script setup lang="ts">
import {
  ItinerarySegmentType,
  isItineraryLocationLoaderSegment,
  isItinerarySimpleTransportLoaderSegment,
  isItineraryBookableProductLoaderSegment,
} from '../../../models';
import { useTripOverviewPageStore } from '../../../stores';
import AddDestinationButton from '../AddDestinationButton.vue';
import ItinerarySimpleTransportSegment from '../ItinerarySimpleTransportSegment.vue';
import ItineraryNoTransportSegment from '../ItineraryNoTransportSegment.vue';
import ItineraryLocationSegment from '../location/ItineraryLocationSegment.vue';
import ItineraryOwnStaySegment from '../ownStay/ItineraryOwnStaySegment.vue';
import ItineraryUpsellNoTransportSegment from '../ItineraryUpsellNoTransportSegment.vue';
import ItineraryStenaUpsellNoTransportSegment from '../ItineraryStenaUpsellNoTransportSegment.vue';

import ItineraryDateRangeLoader from './ItineraryDateRangeLoader.vue';
import ItineraryProductLoaderSegment from './ItineraryProductLoaderSegment.vue';
import ItineraryUpsellingLoader from './ItineraryUpsellingLoader.vue';

const tripOverviewPageStore = useTripOverviewPageStore();
</script>

<template>
  <div class="trip-itinerary-loader">
    <div
      v-for="(segment, index) in tripOverviewPageStore.tripItineraryLoader"
      :key="index"
    >
      <ItineraryDateRangeLoader
        v-if="segment.segmentType === ItinerarySegmentType.DateRange"
        :is-first-segment="index === 0"
        :second-segment-is-no-transport="
          tripOverviewPageStore.tripItinerary[1]?.segmentType ===
            ItinerarySegmentType.NoTransport ||
          tripOverviewPageStore.tripItinerary[1]?.segmentType ===
            ItinerarySegmentType.UpsellNoTransport ||
          tripOverviewPageStore.tripItinerary[1]?.segmentType ===
            ItinerarySegmentType.StenaUpsellNoTransport
        "
      />

      <ItineraryLocationSegment
        v-if="isItineraryLocationLoaderSegment(segment)"
        :segment="segment"
        :print-mode="false"
      />

      <ItineraryNoTransportSegment
        v-if="segment.segmentType === ItinerarySegmentType.NoTransport"
        :segment="segment"
        :print-mode="false"
        @select-transport="
          tripOverviewPageStore.selectTransport(segment, $event)
        "
      />

      <ItineraryUpsellingLoader
        v-if="segment.segmentType === ItinerarySegmentType.Upsell"
      />

      <ItineraryUpsellNoTransportSegment
        v-if="segment.segmentType === ItinerarySegmentType.UpsellNoTransport"
        :segment="segment"
      />

      <ItineraryStenaUpsellNoTransportSegment
        v-if="
          segment.segmentType === ItinerarySegmentType.StenaUpsellNoTransport
        "
        :segment="segment"
      />

      <ItinerarySimpleTransportSegment
        v-if="isItinerarySimpleTransportLoaderSegment(segment)"
        :segment="segment"
        is-loading-transport
        :print-mode="false"
        @select-transport="
          tripOverviewPageStore.selectTransport(segment, $event)
        "
      />

      <ItineraryOwnStaySegment
        v-if="segment.segmentType === ItinerarySegmentType.OwnStay"
        :segment="segment"
      />

      <ItineraryProductLoaderSegment
        v-if="isItineraryBookableProductLoaderSegment(segment)"
        :segment="segment"
      />
    </div>
    <AddDestinationButton />
  </div>
</template>
